const getters = {
    smStocks: state => state.sm_stocks,
    smStock: state => state.sm_stock,
    smStockProductInfo: state => state.sm_stock_product_info,
}

export default getters;
